import type { CodingScreenApi } from '../../project_starburst';

/**
 * Build the `CodingScreenApi` the GRADING shell injects -- the grading counterpart to
 * `codingScreenApiFromCase` (`./codingScreenApi`). Grading loads a `CQAGraderWorkItem`, not a coding
 * `Case`, and none of these actions are wired to a grading backend yet, so every method is a STUB
 * (PT-1).
 *
 * `placeHold` is the one method stubbed PERMANENTLY rather than pending wiring: holds are a CODER
 * action and the grading `DEFAULT_CODING_SCREEN_CONFIG` omits the Hold slot entirely, so a placeHold
 * reaching this adapter is a misuse. It REJECTS with an explicit message rather than resolving as a
 * silent (nothing-persisted) success -- the same "fail loud, never fake success" stance the coding
 * adapter's real `placeHold` takes. Returns a value (never undefined): every method is a stub with no
 * dependency on loaded grading data, so there is nothing to wait for.
 */
export function codingScreenApiFromGrading(): CodingScreenApi {
  return {
    // Coder-only; grading never renders the Hold action. Reject so a stray wire-up surfaces instead
    // of silently "succeeding" without placing anything.
    placeHold: async (): Promise<void> => {
      throw new Error('Holds are not available in grading.');
    },
    // Resolving no-op stubs -- grading has no backend wiring for these yet (PT-1 on CDMX-18412).
    loadNextCase: async (): Promise<void> => {},
    loadCase: async (): Promise<void> => {},
    startReview: (): void => {},
    onCodeSearch: async (): Promise<void> => {}
  };
}
